const maskString = (acc_no: string) => {
  if (!acc_no || acc_no.length <= 4) return acc_no;

  const visible = acc_no.slice(-4);
  const maskedLength = acc_no.length - 4;
  const masked = "*".repeat(maskedLength);

  return `${masked}${visible}`;
};

const makeStructure = (str: string) => {
  const num = Number(str);
  const formatted = num.toLocaleString();
  return formatted;
};

const generateInvoiceNumber = () => {
  const now = new Date();

  const yy = now.getFullYear()?.toString()?.slice(-2); // Last 2 digits of year
  const mm = String(now.getMonth() + 1).padStart(2, "0"); // Month: 01-12
  const dd = String(now.getDate()).padStart(2, "0"); // Day: 01-31

  const hh = String(now.getHours()).padStart(2, "0"); // 00-23
  const min = String(now.getMinutes()).padStart(2, "0"); // 00-59
  const ss = String(now.getSeconds()).padStart(2, "0"); // 00-59

  return `INV-${yy}${mm}${dd}-${hh}${min}${ss}`;
};

const getCurrentDateFormatted = () => {
  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = monthNames[now.getMonth()];
  const year = now.getFullYear();

  return `${day}-${month}-${year}`;
};

const gxIsArray = (value: any) => {
  return Array.isArray(value);
};

function isFloat(n: number): boolean {
  return !Number.isInteger(n);
}

function isArrayEmpty(arr: string | any[]): boolean {
  return arr.length < 0;
}

function gxCapitalizeFirstLetter(str: string): string {
  if (str === "sentForRepair") {
    return "Sent For Repair";
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const utcToLocal = (dateString: string) => {
  if (dateString) {
    const date = new Date(dateString);

    const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(
      date,
    );
    const month = new Intl.DateTimeFormat("en-GB", { month: "short" }).format(
      date,
    );
    const year = new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(
      date,
    );
    const time = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
      .format(date)
      .toLocaleUpperCase();

    const formatted = `${day} ${month} ${year} ${time}`;

    return formatted;
  } else {
    return "";
  }
};

function gxFormatDateDDMMMYYYY(dateInput: string | number | Date): string {
  if (!dateInput) return "";
  const date = new Date(dateInput);

  const day = String(date.getDate()).padStart(2, "0");

  const months: readonly string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

function gxFormatDateYYYYMMDD(dateInput: string | number | Date): string {
  if (!dateInput) return "";
  const date = new Date(dateInput);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function gxFormatDateMMMDDYYYY(dateInput?: string | number | Date): string {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  const months: readonly string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}

function gxFormatDateYYYYMMDDHHMMSS(dateValue: string | number | Date) {
  if (!dateValue) return null;

  const d = new Date(dateValue);

  d.setHours(0, 0, 0, 0);

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const ss = String(d.getSeconds()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
}

function gxFormatTimeHHmm(dateInput: string | number | Date): string {
  if (!dateInput) return "";
  const date = new Date(dateInput);

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
}

export function gxFormatTimeHHmmss(dateInput: string | number | Date): string {
  if (!dateInput) return "";
  const date = new Date(dateInput);

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

function gxAddDays(dateInput: string | number | Date, days: number = 0) {
  if (dateInput) {
    const date = new Date(dateInput);
    const result = new Date(date);
    result.setDate(result.getDate() + days);

    return result;
  }
}

const getCurrentDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const buildPaymentTime = (
  paymentDate: string,
  debitTime: Date | null,
  showTimePicker: boolean,
): string | null => {
  if (!showTimePicker || !debitTime) return null;

  const formattedDate = getCurrentDate(new Date(paymentDate));
  return `${formattedDate}T${debitTime}`;
};

const isObjectNotEmpty = (obj: any) => {
  return Object.keys(obj).length !== 0;
};

// helpers.ts
const countSpecificWeekday = (
  startDate: Date | string,
  endDate: Date | string,
  weekday: number, // 0 = Sunday, 1 = Monday, ... 6 = Saturday
): number => {
  // Normalize inputs to Date objects
  const start = typeof startDate === "string" ? new Date(startDate) : startDate;
  const end = typeof endDate === "string" ? new Date(endDate) : endDate;

  let count = 0;
  const current = new Date(start);

  while (current <= end) {
    if (current.getDay() === weekday) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }

  return count;
};

const currentDomain = () => {
  return globalThis.location.origin;
};

const setTransactionInfo = (transactionInfo: {
  transId: number;
  gxChnNo: string;
}) => {
  const info = JSON.stringify(transactionInfo);
  sessionStorage.setItem("transInfo", info);
};

const getTransactionInfo = () => {
  const info = sessionStorage.getItem("transInfo");
  return JSON.parse(info ?? "") as { transId: number; gxChnNo: string };
};

const clearTransactionInfo = () => {
  sessionStorage.removeItem("transInfo");
};

const setConsentData = (info: {
  flag: string;
  open: boolean;
  openRtp: boolean;
  openSfr: boolean;
  successData: {
    noOfApprovalrequired: number;
    aprdLevel: number;
    debitAmount: number;
    gxChnNo: string;
    debitCurrency: string;
    paymentInitiatedDate: string;
    beneAccountName: string;
  };
}) => {
  const stringifyInfo = JSON.stringify(info);
  sessionStorage.setItem("approveFlag", stringifyInfo);
};

const getConsentData = () => {
  const stringifyInfo = sessionStorage.getItem("approveFlag");
  return stringifyInfo ? JSON.parse(stringifyInfo) : null;
};

const clearConsentData = () => {
  sessionStorage.removeItem("approveFlag");
};

const getValidDate = (dateStr: string): Date => {
  const givenDate = new Date(dateStr);
  const today = new Date();

  // Normalize both dates to midnight (ignore time part)
  const normalize = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const normalizedGiven = normalize(givenDate);
  const normalizedToday = normalize(today);

  if (normalizedGiven < normalizedToday) {
    return normalizedToday; // before → return today
  }
  return normalizedGiven; // today or future → return given date
};

export const getPermissionByMenuId = (
  menuData: any[],
  menuId: number,
  permissionName: string,
) => {
  for (const module of menuData) {
    if (module?.menus?.length) {
      const menu = module.menus.find((m: any) => m.menuId === menuId);
      if (menu) {
        const permission = menu.permissions?.find(
          (p: any) => p.permissionName === permissionName,
        );
        if (permission) {
          return {
            menuId: menu.menuId,
            permissionId: permission.permissionId,
          };
        }
      }
    }
  }
  return null;
};

const isObjectEmpty = (obj: object): boolean => {
  return Object.keys(obj).length === 0;
};

// Bulk CBUAE context helpers
const BULK_CBUAE_KEY = "cbuae_bulk_context";
export interface BulkCbuaeContext {
  gxJobProcessid: number;
  bulkType: string;
  bankName: string;
  source: string;
}

const setBulkCbuaeContext = (context: BulkCbuaeContext): void => {
  try {
    sessionStorage.setItem(BULK_CBUAE_KEY, JSON.stringify(context));
  } catch {}
};

const getBulkCbuaeContext = (): BulkCbuaeContext | null => {
  try {
    const raw = sessionStorage.getItem(BULK_CBUAE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as BulkCbuaeContext;
  } catch {
    return null;
  }
};

const clearBulkCbuaeContext = (): void => {
  sessionStorage.removeItem(BULK_CBUAE_KEY);
};

const checkDateValidity = (
  collectionDate: string | null,
  payLinkExpiryDate: string | null,
): boolean => {
  const dateToCheck = payLinkExpiryDate || collectionDate;

  if (!dateToCheck) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const checkDate = new Date(dateToCheck);
  checkDate.setHours(0, 0, 0, 0);

  return checkDate >= today;
};

export {
  maskString,
  makeStructure,
  generateInvoiceNumber,
  getCurrentDateFormatted,
  gxIsArray,
  isFloat,
  isArrayEmpty,
  gxCapitalizeFirstLetter,
  utcToLocal,
  gxFormatDateDDMMMYYYY,
  gxFormatDateYYYYMMDD,
  gxFormatDateYYYYMMDDHHMMSS,
  gxFormatDateMMMDDYYYY,
  gxFormatTimeHHmm,
  gxAddDays,
  buildPaymentTime,
  isObjectNotEmpty,
  countSpecificWeekday,
  currentDomain,
  setTransactionInfo,
  getTransactionInfo,
  clearTransactionInfo,
  setConsentData,
  getConsentData,
  clearConsentData,
  getValidDate,
  setBulkCbuaeContext,
  getBulkCbuaeContext,
  clearBulkCbuaeContext,
  isObjectEmpty,
  checkDateValidity,
};
